import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { COMPLETE_INVITATION_RESOURCE } from '../constants';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMPLETE_INVITATION_RESOURCE,
      method: 'post',
      request: (token, body, callback) => ({
        url: apiRoutes.completeInvitation(token),
        body,
        meta: { callback },
      }),
    },
  ])(ComposedComponent);
